import React from "react";
import {
  Button,
  FormGroup,
  FormControl,
} from "react-bootstrap";
import "./Comment.css";
import { 
  ArrowUpCircle, 
  ArrowDownCircle,
  ChevronDown,
  ChevronUp
} from 'react-feather';
import defaultAvatar from "../assets/avatar.png"
import LoaderButton from "../components/LoaderButton";

export default function Comment({
  idx,
  cmnts,
  comments,
  comment,
  replies,
  createComment,
  deleteComment,
  interact,
  setComments,
  setReply,
  isCommenting,
  reply
}) {

  return (
    <div key={idx} style={{paddingBottom: "15px", "clear": "both"}}>
      <div
        style={{
          backgroundImage: `url(${comment.author.avatarURL}), url(${defaultAvatar})`,
          verticalAlign: "top"
        }}
        className="article-avatar"
      />
      <span className="comment-text">
        <span className="comment-name">{comment.author.fullname}</span>
        <span className="comment-time">{ comment.time }</span>
        <br/>
        <span style={{"overflowWrap": "break-word", "wordWrap": "break-word"}}>{ comment.text }</span>
      </span>
      <div style={{marginLeft: "58px"}}>
        <span 
          className="interaction-btn"
          style={comment.upVoted ? {color: '#ff7f01'} : null}
          onClick={()=>interact(comments, 'up', idx)}
        >
          <ArrowUpCircle style={{verticalAlign: "-3px"}} strokeWidth={3} size={18} /> {comment.ups}
        </span>
        <span 
          className="interaction-btn"
          style={comment.downVoted ? {color: '#ff7f01'} : null}
          onClick={()=>interact(comments, 'down', idx)}
        >
          <ArrowDownCircle style={{verticalAlign: "-3px"}} strokeWidth={3} size={18} /> {comment.downs}
        </span>
        <span className="award-text">
          { comment.award ? "+" + comment.award + " i¢" : null }
          { !comment.awarded ? <Button onClick={()=>interact(comments, 'award', idx)} className="award-btn">award i¢</Button> : null }
        </span>
        <span className="award-text" style={{marginLeft: "6px"}}>
          <Button 
            onClick={()=>{
              comments = comments.map(cmnt => {cmnt.showReply = false; return cmnt;});
              comments[idx].showReply = true;
              setComments(comments);
            }} 
            className="award-btn"
          >
            reply
          </Button>
        </span>
        {
          comment.canDelete ? (
            <span className="award-text" style={{marginLeft: "6px"}}>
              <Button 
                onClick={()=>deleteComment(comments, idx)} 
                className="award-btn"
              >
                delete
              </Button>
            </span>
          ) : null
        }
      </div>
      {
        comment.showReply ? (
          <div style={{marginTop: "5px", marginLeft: "58px"}}>
            <FormGroup style={{marginBottom: "5px"}}>
              <FormControl 
                      style={{
                        resize: "vertical",
                        width: "100%",
                        minHeight: "80px",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                      }}
                componentClass="textarea" 
                value={reply}
                placeholder="Reply..."
                onChange={e => setReply(e.target.value)}
              />
            </FormGroup>
            <button
              className="submit-btn"
              onClick={()=>createComment(reply, idx)}
              isLoading={isCommenting}
            >
              Submit
            </button>
          </div>
        ) : null
      }
      {
        replies[comment.comment_id] ? 
          !comment.showReplies ? (
            <div 
              className="show-hide"
              onClick={()=>{
                let cmnts = [...comments];
                cmnts[idx].showReplies = true;
                setComments(cmnts);
              }}
            > 
              <ChevronDown style={{verticalAlign: "-5px"}}/> 
              <span style={{verticalAlign: "2px", whiteSpace: 'nowrap', display: 'inline-block'}}>Show Replies ({replies[comment.comment_id].length})</span>
            </div>
          ) : (
            <div 
              className="show-hide"
              onClick={()=>{
                let cmnts = [...comments];
                cmnts[idx].showReplies = false;
                setComments(cmnts);
              }}
            > 
              <ChevronUp style={{verticalAlign: "-5px"}}/> 
              <span style={{verticalAlign: "2px"}}>Hide Replies</span>
            </div>
          ) 
        : null
      }
      {
        replies[comment.comment_id] && comment.showReplies ? 
          replies[comment.comment_id].map((reply, ridx) => (
          <div key={ridx} style={{marginTop: "5px", marginLeft: "58px"}}>
            <div
              style={{
                backgroundImage: `url(${reply.author.avatarURL}), url(${defaultAvatar})`,
                verticalAlign: "top",
                width: "32px",
                height: "32px"
              }}
              className="article-avatar"
            />
            <span className="comment-text">
              <span className="comment-name">{reply.author.fullname}</span>
              <span className="comment-time">{ reply.time }</span>
              <br/>
              <span>{ reply.text }</span>
            </span>
            <div style={{marginLeft: "42px"}}>
              <span 
                className="interaction-btn"
                style={reply.upVoted ? {color: '#ff7f01'} : null}
                onClick={()=>interact(comments, 'up', idx, ridx)}
              >
                <ArrowUpCircle style={{verticalAlign: "-3px"}} strokeWidth={3} size={18} /> {reply.ups}
              </span>
              <span 
                className="interaction-btn"
                style={reply.downVoted ? {color: '#ff7f01'} : null}
                onClick={()=>interact(comments, 'down', idx, ridx)}
              >
                <ArrowDownCircle style={{verticalAlign: "-3px"}} strokeWidth={3} size={18} /> {reply.downs}
              </span>
              <span className="award-text">
                { reply.award ? "+" + reply.award + " i¢" : null }
                { !reply.awarded ? <Button onClick={()=>interact(comments, 'award', idx, ridx)} className="award-btn">award i¢</Button> : null }
              </span>
              {
                reply.canDelete ? (
                  <span className="award-text" style={{marginLeft: "6px"}}>
                    <Button 
                      onClick={()=>deleteComment(comments, idx, ridx)} 
                      className="award-btn"
                    >
                      delete
                    </Button>
                  </span>
                ) : null
              }
            </div>
          </div>
        )) : null
      }
    </div>
  );
}